import { Component, ElementRef, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { ActivatedRoute } from '@angular/router';
import { servicesUrl } from 'src/app/services/servicesUrl';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-vacancy',
  templateUrl: './vacancy.component.html',
  styleUrls: ['./vacancy.component.css']
})
export class VacancyComponent implements OnInit {
  arrayVecancyCategory:any
  arrayVecancy:any
  id: any
  selectedItem: any
  load: boolean = false
  url:string=''

  constructor(private elementRef: ElementRef,private url_:servicesUrl ,private homeService_: HomeService,private _Activatedroute: ActivatedRoute) {
    this._Activatedroute.paramMap.subscribe(params => {
      window.scroll(0, 0);
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.url = this.url_.imgUrl
    this.load = false;

    this.id = this._Activatedroute.snapshot.paramMap.get("id")


    var s15 = document.createElement("script");
    s15.type = "text/javascript";
    s15.src = "../../../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s15);

    if (this.id == null || this.id == '') {
      this.selectedItem = null

      this.homeService_.getPost('getPost','', 'en', '', 'VecancyCategory', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayVecancyCategory = data
        this.homeService_.getPost('getPostDetails', '', 'en', '', 'Vecancy', '', '', '-1').subscribe(data => {
          this.arrayVecancy = data
          setTimeout(() => {
            this.load = true
          }, 200);
        })
      })
    }
    else{
    this.homeService_.getPost('getPost','', 'en', '', 'VecancyCategory', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayVecancyCategory = data
    this.homeService_.getPost('getPostDetails', '', 'en', '', 'Vecancy', this.id, '', '-1').subscribe(data => {
          this.selectedItem = this.id
          this.arrayVecancy = data
          setTimeout(() => {
            this.load = true
          }, 200);
           })
      })
    }
  }

  getVecancy(sectionId: string) {
    this.load = false

    this.selectedItem = sectionId

    this.homeService_.getPost('getPostDetails', '', 'en', '', 'Vecancy', sectionId, '', '-1').subscribe(data => {
      this.arrayVecancy = data
      setTimeout(() => {
        this.load = true
      }, 200);

    })


  }



}
